export default "__VITE_ASSET__CoN91mnF__"